/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { IWebSocketClient, WebsocketProviders } from './types';
import { FayeClient } from './faye/fayeClient';
export class WebSocketClientFactory {
  static createClient(clientType: WebsocketProviders): IWebSocketClient {
    switch (clientType) {
      case WebsocketProviders.FAYE:
        return new FayeClient();
      default:
        throw new Error('Unsupported WebSocket client type');
    }
  }
}
